module.exports = __webpack_public_path__ + "static/media/vg.b37358a1.svg";